const actions = {
    STAFF_PROFILES_FETCH_REQUEST: 'STAFF_PROFILES_FETCH_REQUEST',
    STAFF_PROFILES_FETCH_SUCCESS: 'STAFF_PROFILES_FETCH_SUCCESS',
    STAFF_PROFILES_RESET: 'STAFF_PROFILES_RESET',
    STAFF_PROFILES_SET_LOADING: 'STAFF_PROFILES_SET_LOADING',

    fetchCurrentStaffProfile: () => ({
        type: actions.STAFF_PROFILES_FETCH_REQUEST
    })
}

export default actions
